import React from 'react'
import OneNavLink from './OneNavLink'
import OneNavLinkDropdown from './OneNavLinkDropdown'
import { Link, useLocation } from 'react-router-dom'

// Sources

const NavBar = () => {
    const location = useLocation()
    const { pathname } = location
    const splitLocation = pathname.split('/')
    const pageName = '/' + splitLocation[1]
    return (
        <>
            {/* <OneNavLinkDropdown 
    NavItem="Why 800 Homes"
    Link="/why-800-homes"
    DropdownMenu={<>
    <OneNavLink 
    NavItem="Leadership"
    Link="/leadership"
    />
    </>}
    /> */}

            <OneNavLinkDropdown
                NavItem="Why 800 Homes"
                Link="/why-800-homes"
                DropdownMenu={
                    <>
                        <div className="fw-400 fs-header-link px-md-3 mx-md-1">
                            <Link
                                to="/leadership/"
                                className={`text-decoration-none text-ss-primary text-hover-ss-primary ${
                                    pageName === '/leadership' ? 'text-ss-primary text-hover-ss-primary' : 'text-dark'
                                }`}
                            >
                                Leadership
                            </Link>
                        </div>
                        <div className="dropdown-divider" style={{ margin: '0.5rem 0' }}></div>
                        <div className="fw-400 fs-header-link px-md-3 mx-md-1">
                            <Link
                                to="/our-team"
                                className={`text-decoration-none text-ss-primary text-hover-ss-primary ${
                                    pageName === '/our-team' ? 'text-ss-primary text-hover-ss-primary' : 'text-dark'
                                }`}
                            >
                                Our Team
                            </Link>
                        </div>
                        <div className="dropdown-divider" style={{ margin: '0.5rem 0' }}></div>
                        <div className="fw-400 fs-header-link px-md-3 mx-md-1">
                            <Link
                                to="/awards-and-achievements"
                                className={`text-decoration-none text-ss-primary text-hover-ss-primary ${
                                    pageName === '/awards-and-achievements' ? 'text-ss-primary text-hover-ss-primary' : 'text-dark'
                                }`}
                            >
                                Awards & Achievements
                            </Link>
                        </div>
                        <div className="dropdown-divider" style={{ margin: '0.5rem 0' }}></div>
                        <div className="fw-400 fs-header-link px-md-3 mx-md-1">
                            <Link
                                to="/dubai-property-investment"
                                className={`text-decoration-none text-ss-primary text-hover-ss-primary ${
                                    pageName === '/dubai-property-investment' ? 'text-ss-primary text-hover-ss-primary' : 'text-dark'
                                }`}
                            >
                                Property Investment
                            </Link>
                        </div>
                    </>
                }
            />

            <OneNavLink NavItem="Why Dubai" Link="/why-dubai" />

            <OneNavLink NavItem="Buy Property" Link="/properties-for-sale" />
            {/* <OneNavLink NavItem="Mortgage Calculator" Link="/mortgage-calculator" /> */}
            <OneNavLink NavItem="Sell Property" Link="/sell-property" />
              <div className="fw-400 fs-header-link px-md-2 px-lg-3 mx-lg-1 pb-4 pb-md-0">
                        <a href="https://800homes.ae/blogs/" className={`text-decoration-none text-hover-ss-primary ${pageName === "/blogs" ? "text-ss-primary text-hover-ss-primary" : "text-white"}`}> Blogs </a>     
                    </div>
            <OneNavLink NavItem="Mortgage" Link="/mortgage-calculator" />
            <OneNavLink NavItem="Contact Us" Link="/contact-us" />
        </>
    )
}

export default NavBar
